import { render } from "./FiltersFormV2.vue?vue&type=template&id=a06abfb4&scoped=true"
import script from "./FiltersFormV2.vue?vue&type=script&lang=js"
export * from "./FiltersFormV2.vue?vue&type=script&lang=js"

import "./FiltersFormV2.vue?vue&type=style&index=0&id=a06abfb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a06abfb4"]])

export default __exports__